import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ds } from '@/components/lib/design.system';

// this indicator should be used from now on for all modals
export const ModalPullDownIndicator = ({ color }: { color?: string }) => {
    return (
        <View style={styles.root}>
            <View style={{ ...styles.base, ...(color ? { backgroundColor: color } : {}) }} />
        </View>
    );
};

const styles = StyleSheet.create({
    root: {
        alignItems: 'center',
    },
    base: {
        height: 4,
        width: 36,
        backgroundColor: ds.colorValue.background.neutral.subtle,
        borderRadius: 3,
        borderCurve: 'continuous',
    },
});
